import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from "../instance-settings/instance-settings.service";
import { IHttpService } from "angular";

export const HEADER_SERVICE: string = "headerService";

export class HeaderService {
    private internalHeaderTitle : string = "";

    static $inject = ["$http", INSTANCE_SETTINGS_SERVICE];
    constructor(private $http: IHttpService, private instanceSettingService: InstanceSettingsService) { }

    getSettings(): any {
        return this.instanceSettingService.getSettings().then((response) => { return response; });
    }

    get headerTitle(): string {
        return this.internalHeaderTitle;
    }
    set headerTitle(value: string) {
        this.internalHeaderTitle = value;
    }
}


// WEBPACK FOOTER //
// ./app/core/header.service.ts